import { Injectable, ElementRef } from '@angular/core';
export class FooterService {
public elementRef: ElementRef;
/**
 * [offsetHeight description]
 * \@method offsetHeight
 * @return {?}
 */
public get offsetHeight(): number {
    return this.elementRef.nativeElement.offsetHeight;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FooterService_tsickle_Closure_declarations() {
/** @type {?} */
FooterService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FooterService.ctorParameters;
/** @type {?} */
FooterService.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
